module.exports = __webpack_public_path__ + "static/media/goldenprize-mackerel-tomato.c0ada490.png";